import DOMPurify from 'dompurify';

export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html);

export const escapeJsonForScriptTag = (value: unknown): string =>
    JSON.stringify(value)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029');
